/* eslint-disable no-console */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import Validate from "./FormValidation";
import classNames from "classnames";

import { Auth, API, graphqlOperation } from "aws-amplify";
import { createCustomer } from "../graphql/mutations";
import * as googleMap from "react-google-maps";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Autocomplete from "react-google-autocomplete";
import awsConfigSettings from "../aws-exports";

import { green } from "@material-ui/core/colors";
import Radio from "@material-ui/core/Radio";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardText,
  CardTitle,
  CardFooter,
  FormGroup,
  Form,
  Input,
  InputGroup,
  Container,
  Row,
  Col,
  FormFeedback,
  FormText
} from "reactstrap";
import TextField from "@material-ui/core/TextField";
import NumberFormat from "react-number-format";

const GreenRadio = withStyles({
  root: {
    color: green[400],
    "&$checked": {
      color: green[600]
    }
  },
  checked: {}
})(props => <Radio color="default" {...props} />);

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    //flexGrow: 1,
    background: "white",
    paddingLeft: "25px",
    paddingRight: "25px"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  dense: {
    marginTop: 16
  },
  menu: {
    width: 200
  }
});
class CustomerRegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      regType: null,
      company: null,
      _company: {
        value: null,
        isValid: true,
        err: ""
      },
      fName: null,
      _fName: {
        value: null,
        isValid: true,
        err: ""
      },
      lName: null,
      _lName: {
        value: null,
        isValid: true,
        err: ""
      },
      username: null,
      _username: {
        value: null,
        isValid: true,
        err: ""
      },
      email: null,
      _email: {
        value: null,
        isValid: true,
        err: ""
      },
      password: null,
      _password: {
        value: null,
        isValid: true,
        err: ""
      },
      cPassword: null,
      _cPassword: {
        value: null,
        isValid: true,
        err: ""
      },
      address: null,
      _address: {
        value: null,
        isValid: true,
        err: ""
      },
      city: "",
      _city: {
        value: null,
        isValid: true,
        err: ""
      },
      state: "",
      _state: {
        value: null,
        isValid: true,
        err: ""
      },
      zipCode: "",
      _zipCode: {
        value: null,
        isValid: true,
        err: ""
      },
      phoneNum: null,
      _phoneNum: {
        value: null,
        isValid: true,
        err: ""
      },
      passwordValidate: true,
      phoneValidated: true,
      lat: "",
      lng: "",
      selectedInspectionType: "",
      inspectionTypeErr: "",
      addressType: "",
      errors: {
        cognito: null,
        blankfield: false,
        passwordmatch: false
      },
      emailValidate: true,
      emailFeadback: null,
      usernameValidate: true,
      usernameFeadback: null
    };
  }
  // static contextType = Context;
  clearErrorState = () => {
    this.setState({
      errors: {
        cognito: null,
        blankfield: false,
        passwordmatch: false
      }
    });
  };
  checkValidate = () => {
    let { passwordValidate, phoneValidated } = this.state;
    if (!passwordValidate) {
      document.getElementById("password").focus();
      return false;
    } else if (!phoneValidated) {
      document.getElementById("phoneNum").focus();
      return false;
    } else {
      return true;
    }
  };

  handleSubmit = async event => {
    event.preventDefault();
    if (event.target.name === "submit") {
      let {
        company,
        fName,
        lName,
        username,
        email,
        password,
        cPassword,
        address,
        city,
        state,
        phoneNum,
        selectedInspectionType,
        zipCode,
        passwordValidate,
        phoneValidated,
        emailValidate,
        lat,
        lng,
        test,
        _company,
        _fName,
        _lName,
        _cPassword,
        _username,
        _password,
        _address,
        _city,
        _phoneNum,
        _email,
        _state,
        _zipCode
      } = this.state;
      if (
        !_company.isValid ||
        _company.value === null ||
        _company.value === undefined
      ) {
        this.submitCheck("_company", _company.value);
        document.getElementById("_company").focus();
      }
      if (
        !_fName.isValid ||
        _fName.value === null ||
        _fName.value === undefined
      ) {
        this.submitCheck("_fName", _fName.value);
        document.getElementById("_fName").focus();
      }
      if (
        !_lName.isValid ||
        _lName.value === null ||
        _lName.value === undefined
      ) {
        this.submitCheck("_lName", _lName.value);
        document.getElementById("_lName").focus();
      }
      if (
        !_username.isValid ||
        _username.value === null ||
        _username.value === undefined
      ) {
        this.submitCheck("_username", _username.value);
        document.getElementById("_username").focus();
      }
      if (
        !_password.isValid ||
        _password.value === null ||
        _password.value === undefined
      ) {
        this.submitCheck("_password", _password.value);
        document.getElementById("_password").focus();
      }
      if (
        !_cPassword.isValid ||
        _cPassword.value === null ||
        _cPassword.value === undefined
      ) {
        this.submitCheck("_cPassword", _cPassword.value);
        document.getElementById("_cPassword").focus();
      }
      if (
        !phoneValidated ||
        _phoneNum.value === "" ||
        _phoneNum.value === null ||
        _phoneNum.value === undefined
      ) {
        this.setState({
          _phoneNum: {
            value: this.state._phoneNum.value,
            isValid: false,
            err: "Phone Number Not Valid"
          }
        });
        document.getElementById("_phoneNum").focus();
      }
      if (
        !emailValidate ||
        !_email.isValid ||
        _phoneNum.value === null ||
        _phoneNum.value === undefined
      ) {
        this.submitCheck("_email", _email.value);
        document.getElementById("_email").focus();
      }
      if (address === null || address === "" || lat === "" || lng === "") {
        this.setState({
          _address: {
            isValid: false,
            err: "Kindly Select Your Location Properly"
          }
        });
        document.getElementById("address").focus();
      }
      if (
        !_city.isValid ||
        city === null ||
        city === undefined ||
        city === ""
      ) {
        this.submitCheck("_city", city);
        document.getElementById("city").focus();
      }
      if (
        !_state.isValid ||
        state === null ||
        state === undefined ||
        state === ""
      ) {
        this.submitCheck("_state", state);
        document.getElementById("state").focus();
      }
      if (
        !_zipCode.isValid ||
        zipCode === null ||
        zipCode === undefined ||
        zipCode === ""
      ) {
        this.submitCheck("_zipCode", zipCode);
        document.getElementById("zipCode").focus();
      }
      if (!document.getElementById("cbRegister").checked)
        document.getElementById("cbRegister").focus();
      // if (lat === "" || lng === "") {
      //   document.getElementById("address").focus();
      // }
      if (
        (selectedInspectionType === "" ||
          selectedInspectionType === null ||
          selectedInspectionType === undefined) &&
        this.props.match.params.type === "customer"
      ) {
        this.setState({
          inspectionTypeErr: "Kindly Select Atleast One Type"
        });
        // if (
        //   this.state.inspectionTypeErr !== "" ||
        //   this.state.inspectionTypeErr !== null ||
        //   this.state.inspectionTypeErr !== undefined
        // ) {
        //   document.getElementById("inspectionTypeCard1").style.borderColor =
        //     "red";
        //   document.getElementById("inspectionTypeCard1").style.borderWidth =
        //     "medium";
        //   document.getElementById("inspectionTypeCard1").style.borderStyle =
        //     "solid";
        // }
      } else {
        try {
          phoneNum = _phoneNum.value;
          company = _company.value;
          fName = _fName.value;
          lName = _lName.value;
          username = _username.value.toLowerCase();
          password = _password.value;
          cPassword = _cPassword.value;
          this.setState({
            phoneNum: _phoneNum.value,
            company: _company.value,
            fName: _fName.value,
            lName: _lName.value,
            username: _username.value.toLowerCase(),
            password: _password.value,
            cPassword: _cPassword.value
          });
          phoneNum = phoneNum.replace("(", "");
          phoneNum = phoneNum.replace(")", "");
          phoneNum = phoneNum.replace("-", "");
          phoneNum = phoneNum.replace(" ", "");
          phoneNum = "+1" + phoneNum;
          const signUpResponse = await Auth.signUp({
            username,
            password,
            attributes: {
              //email: email
              phone_number: phoneNum
            }
          });

          const customerAddresses = [];
          const custAddress = {
            phoneNo: phoneNum !== "" ? phoneNum : null,
            address,
            city,
            state: state,
            zipCode,
            addressType: "PRIMARY",
            locationLat: "",
            locationLong: ""
          };
          customerAddresses.push(custAddress);
          this.setState({ id: signUpResponse.userSub });
          localStorage.setItem("userInfo", JSON.stringify(this.state));
          this.props.history.push(
            "/Confirmation/" + this.props.match.params.type
          );
        } catch (err) {
          toast.error(err.message);
          if (err.code === "UsernameExistsException") {
            document.getElementById("_username").focus();
            this.setState({
              usernameValidate: false,
              usernameFeadback: "Username already exist!"
            });
          }
          this.setState({
            errors: {
              ...this.state.errors,
              cognito: err
            }
          });
        }
      }
    }
  };
  onUsernameChange = event => {
    let val = event.target.value.toLowerCase();
    this.setState({
      [event.target.id]: val,
      usernameValidate: false,
      usernameFeadback: ""
    });
  };

  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    if (
      event.target.id === "city" ||
      event.target.id === "state" ||
      event.target.id === "zipCode" ||
      event.target.id === "address"
    ) {
      const str = "_" + event.target.id;
      this.setState({
        [str]: {
          value: event.target.value,
          isValid: true,
          err: ""
        }
      });
    }
    if (event.target.id === "selectedInspectionType") {
      this.setState({
        inspectionTypeErr: ""
      });
    }
  };

  _onInputChange = event => {
    this.setState({
      [event.target.id]: {
        value: event.target.value,
        isValid: true,
        err: ""
      }
    });
  };

  submitCheck = (id, value) => {
    let arr = ["_username", "_phoneNum", "_password", "_cPassword", "_email"];

    if (value === "" || value === null || value === undefined) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "This Field is Required"
        }
      });
    } else if (value.length > 0) {
      if (id === "_username" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 6 Characters Are Reuired"
          }
        });
      } else if (!arr.includes(id) && value.length < 3)
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 3 Characters Are Reuired"
          }
        });
      else if (id === "_password" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Must be Atleast 6 Characters Long"
          }
        });
      } else if (id === "_cPassword" && value !== this.state._password.value) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Doesn't Match"
          }
        });
      } else if (!this.state.emailValidate && id === "_email") {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Email Entered is Not Valid"
          }
        });
      }
    }
  };

  runtimeCheck = event => {
    let { id, value } = event.target;
    let arr = [
      "_username",
      "_phoneNum",
      "_password",
      "_cPassword",
      "_email",
      "_city",
      "_state",
      "_zipCode"
    ];

    if (value === "" || value === null || value === undefined) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "This Field is Required"
        }
      });
    } else if (value.length > 0) {
      if (id === "_username" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 6 Characters Are Reuired"
          }
        });
      } else if (!arr.includes(id) && value.length < 3)
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 3 Characters Are Reuired"
          }
        });
      else if (id === "_password" && value.length < 6) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Must be Atleast 6 Characters Long"
          }
        });
      } else if (id === "_cPassword" && value !== this.state._password.value) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Password Doesn't Match"
          }
        });
      } else if (!this.state.emailValidate && id === "_email") {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Email Entered is Not Valid"
          }
        });
      }
    }
  };

  onPasswordChange = (e, otherPassword) => {
    e.currentTarget.type = "password";
    this.setState({ [e.target.id]: e.target.value });
    if (e.target.value !== otherPassword)
      this.setState({ passwordValidate: false });
    else this.setState({ passwordValidate: true });
  };

  _onPasswordChange = e => {
    e.currentTarget.type = "password";
    let { id, value } = e.target;
    this.setState({
      [id]: {
        value,
        isValid: true,
        err: ""
      }
    });
    if (id === "_password" && value.length < 6 && value.length > 0) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "Password Must be Atleast 6 Characters Long"
        }
      });
    }
    if (id === "_cPassword" && value !== this.state._password.value) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "Password Doesn't Match"
        }
      });
    }
  };

  onEmailChange = e => {
    let { id, value } = e.target;
    value = value.toLowerCase();
    this.setState({ email: value });
    if (!/.+@.+\.[A-Za-z]+$/.test(value)) {
      this.setState({
        [id]: {
          value,
          isValid: true,
          err: ""
        },
        emailValidate: false
      });
    } else
      this.setState({
        [id]: {
          value,
          isValid: true,
          err: ""
        },
        emailValidate: true
      });
  };
  checkUsernameAvailability = async e => {
    // return;
    let { value } = e.target;
    if (value === "" || value === null) return;
    value = value.toLowerCase();
    this.setState({ username: value });
    /*
    try {
      const signUpResponse = await Auth.signUp({
        username: value,
        password: "12325",
        attributes: {
          email: "abc@test.com"
        }
      });
    } catch (err) {
      // toast.error(err.message);
      if (err.code === "UsernameExistsException")
        document.getElementById("username").focus();
      this.setState({
        usernameValidate: false,
        usernameFeadback: "Username already exist!"
      });
    }
    */

    let userExists = true;
    Auth.signIn({ username: value, password: "eeeeee" })
      .then(res => {})
      .catch(error => {
        const code = error.code;
        switch (code) {
          case "UserNotFoundException":
            //return !this.redirectToRegister(email);
            userExists = false;
            break;
          case "NotAuthorizedException":
            userExists = true;
            break;
          case "PasswordResetRequiredException":
            userExists = true;
            break; // !this.forgotPassword(email);
          case "UserNotConfirmedException":
            userExists = true;
            break; // !this.redirectToCompleteRegister(email);
          default:
            userExists = false;
            break;
        }
        if (error.code !== "UserNotFoundException")
          this.setState({
            usernameValidate: false,
            usernameFeadback: "Username already exist!"
          });
        else this.setState({ usernameValidate: true });
      });

    /*
    this.setState({ username: value, emailValidate: false, emailFeadback: "" });
    let check = await this.isUsernameExist(value);
    if (check) {
      this.setState({ usernameValidate: true });
    } else {
      this.setState({
        usernameValidate: false,
        usernameFeadback: "Username already exist! Pleas select another."
      });
    }
*/
    /*
    Auth.signIn({ username: value, password: "123" })
      .then(res => {
      })
      .catch(err => {
        if (err.code !== "NotAuthorizedException")
         
        else 
      });*/
  };
  async isUsernameExist(username) {
    const code = "025413";
    await Auth.confirmSignUp(username, code, {
      // If set to False, the API will throw an AliasExistsException error if the phone number/email used already exists as an alias with a different user
      forceAliasCreation: true
    })
      .then(() => {})
      .catch(err => {
        switch (err.code) {
          case "UserNotFoundException":
            return true;
          case "NotAuthorizedException":
            return false;
          case "AliasExistsException":
            // Email alias already exists
            return false;
          case "CodeMismatchException":
            return false;
          case "ExpiredCodeException":
            return false;
          default:
            return false;
        }
      });
  }
  onPhoneChange = e => {
    let { id, value } = e.target;
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (value.match(phoneno)) {
      this.setState({ [id]: value, phoneValidated: true });
    } else {
      this.setState({ [id]: value, phoneValidated: false });
    }
  };

  _onPhoneChange = e => {
    let { id, value } = e.target;
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (value.match(phoneno)) {
      this.setState({
        [id]: {
          value,
          isValid: true,
          err: ""
        },
        phoneValidated: true
      });
    } else {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "Phone Num Not Valid"
        },
        phoneValidated: false
      });
    }
  };

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }

  render() {
    let regType = "Customer";
    let inspectionTypeUI;
    if (this.props.match.params.type === undefined) {
      return (
        <div>
          <h3>Registration type is not properly selected. Please try again.</h3>
        </div>
      );
    } else if (this.props.match.params.type === "vendor") {
      regType = "Vendor";
    } else if (this.props.match.params.type === "tvendor") {
      regType = "Tire Vendor";
    } else {
      inspectionTypeUI = (
        <div style={{ width: "100%" }}>
          <h4
            style={{
              color: this.state.inspectionTypeErr !== "" ? "red" : ""
            }}
            id="inspectionTypeCard1"
          >
            Select your Inspection Type
          </h4>
          <div
            style={{
              fontSize: "small",
              marginLeft: "10px",
              color: "red"
            }}
          >
            <text>
              {this.state.inspectionTypeErr !== "" &&
                this.state.inspectionTypeErr}
            </text>
          </div>
          <Container className="pt-lg-sm pt-2">
            <Row form>
              <Col md={7}>
                <Card
                  body
                  onClick={e => {
                    this.setState({
                      selectedInspectionType: "FEDERAL",
                      inspectionTypeErr: ""
                    });
                  }}
                  style={{
                    borderWidth:
                      this.state.selectedInspectionType === "FEDERAL"
                        ? "2px"
                        : "thin",
                    borderColor: "green"
                  }}
                >
                  <CardText>
                    <GreenRadio
                      checked={this.state.selectedInspectionType === "FEDERAL"}
                      onChange={this.onInputChange}
                      value="FEDERAL"
                      id="selectedInspectionType"
                      name="radio-button-demo"
                      inputProps={{ "aria-label": "C" }}
                    />
                    Federal Annual
                  </CardText>
                </Card>
              </Col>
              <Col md={5}>
                <Card
                  body
                  onClick={e => {
                    this.setState({
                      selectedInspectionType: "BIT",
                      inspectionTypeErr: ""
                    });
                  }}
                  style={{
                    borderWidth:
                      this.state.selectedInspectionType === "BIT"
                        ? "2px"
                        : "thin",
                    borderColor: "green"
                  }}
                >
                  <CardText>
                    <GreenRadio
                      checked={this.state.selectedInspectionType === "BIT"}
                      onChange={this.onInputChange}
                      value="BIT"
                      id="selectedInspectionType"
                      name="radio-button-demo"
                      inputProps={{ "aria-label": "C" }}
                    />
                    California BIT
                  </CardText>
                </Card>
              </Col>
            </Row>
            <Row form style={{ marginTop: "2px" }}>
              <Col md={7}>
                <Card
                  body
                  onClick={e => {
                    this.setState({
                      selectedInspectionType: "FEDERAL_BIT",
                      inspectionTypeErr: ""
                    });
                  }}
                  style={{
                    borderWidth:
                      this.state.selectedInspectionType === "FEDERAL_BIT"
                        ? "2px"
                        : "thin",
                    borderColor: "green"
                  }}
                >
                  <CardText>
                    <GreenRadio
                      checked={
                        this.state.selectedInspectionType === "FEDERAL_BIT"
                      }
                      onChange={this.onInputChange}
                      value="FEDERAL_BIT"
                      id="selectedInspectionType"
                      name="radio-button-demo"
                      inputProps={{ "aria-label": "C" }}
                    />
                    Both Federal and California BIT
                  </CardText>
                </Card>
              </Col>
              <Col md={5}>
                <Card
                  body
                  onClick={e => {
                    this.setState({
                      selectedInspectionType: "BUS_LIMOS",
                      inspectionTypeErr: ""
                    });
                  }}
                  style={{
                    borderWidth:
                      this.state.selectedInspectionType === "BUS_LIMOS"
                        ? "2px"
                        : "thin",
                    borderColor: "green"
                  }}
                >
                  <CardText>
                    <GreenRadio
                      checked={
                        this.state.selectedInspectionType === "BUS_LIMOS"
                      }
                      onChange={this.onInputChange}
                      value="BUS_LIMOS"
                      id="selectedInspectionType"
                      name="radio-button-demo"
                      inputProps={{ "aria-label": "C" }}
                    />
                    Buses/Limos
                  </CardText>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      );
    }
    let {
      passwordValidate,
      phoneValidate,
      emailValidate,
      usernameValidate
    } = this.state;
    const { classes } = this.props;

    return (
      <div>
        {" "}
        <Container className="pt-lg-sm pt-2">
          <Row className="justify-content-center">
            <Col lg="8" style={{ background: "white", padding: "25px" }}>
              <div>
                <div className=" pb-2">
                  <span style={{ fontSize: "30px" }}>
                    Register As {regType}
                  </span>
                </div>
                <div className="pb-1">
                  <p style={{ fontSize: "20px" }}> Create a new account </p>
                </div>
              </div>
              <hr></hr>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid item md={12} xs={12}>
                  <TextField
                    id="_company"
                    label="Company Name"
                    placeholder="Company Name"
                    className={classes.textField}
                    margin="normal"
                    onChange={this._onInputChange}
                    value={this.state._company.value}
                    variant="outlined"
                    error={!this.state._company.isValid}
                    helperText={this.state._company.err}
                    fullWidth
                    required
                    onBlur={e => this.runtimeCheck(e)}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    label="First Name"
                    placeholder="First Name"
                    className={classes.textField}
                    margin="normal"
                    id="_fName"
                    onChange={this._onInputChange}
                    value={this.state._fName.value}
                    error={!this.state._fName.isValid}
                    helperText={this.state._fName.err}
                    onBlur={e => this.runtimeCheck(e)}
                    variant="outlined"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    id="_lName"
                    label="Last Name"
                    placeholder="Last Name"
                    className={classes.textField}
                    margin="normal"
                    onChange={this._onInputChange}
                    value={this.state._lName.value}
                    error={!this.state._lName.isValid}
                    helperText={this.state._lName.err}
                    onBlur={e => this.runtimeCheck(e)}
                    variant="outlined"
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  {" "}
                  <TextField
                    id="_username"
                    label="User Name"
                    placeholder="User Name (Used to login the system)"
                    className={classes.textField}
                    margin="normal"
                    onChange={this._onInputChange}
                    value={this.state._username.value}
                    error={!this.state._username.isValid}
                    helperText={this.state._username.err}
                    onBlur={e => this.runtimeCheck(e)}
                    variant="outlined"
                    fullWidth
                    required
                  />
                  <FormFeedback>{this.state.usernameFeadback}</FormFeedback>
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    id="_password"
                    label="Password"
                    placeholder="Password"
                    className={classes.textField}
                    margin="normal"
                    // onChange={e =>
                    //   this.onPasswordChange(e, this.state.cPassword)
                    // }
                    onChange={e => this._onPasswordChange(e)}
                    value={this.state._password.value}
                    error={!this.state._password.isValid}
                    helperText={this.state._password.err}
                    // onBlur={e => this.runtimeCheck(e)}
                    variant="outlined"
                    fullWidth
                    // helperText="At least 6 characters long"
                    required
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    id="_cPassword"
                    label="Confirm Password"
                    placeholder="Confirm Password"
                    className={classes.textField}
                    margin="normal"
                    // onChange={e =>
                    //   this.onPasswordChange(e, this.state.password)
                    // }
                    onChange={e => this._onPasswordChange(e)}
                    value={this.state._cPassword.value}
                    error={!this.state._cPassword.isValid}
                    helperText={this.state._cPassword.err}
                    variant="outlined"
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <NumberFormat
                    className={classes.textField}
                    invalid={!this.state._phoneNum.isValid}
                    style={{
                      height: "57px",
                      width: "100%",
                      marginTop: 16,
                      borderColor: this.state._phoneNum.isValid ? "" : "red"
                    }}
                    id="_phoneNum"
                    onChange={e => this._onPhoneChange(e)}
                    placeholder="Phone No (541) 754-3010"
                    type="tel"
                    format="(###) ###-####"
                    value={this.state._phoneNum.value}
                    name="phoneNum"
                    autoComplete={
                      this.state._phoneNum.value === ""
                        ? ""
                        : this.state._phoneNum.value
                    }
                    required
                  />
                  {!this.state._phoneNum.isValid && (
                    <text
                      style={{ color: "red", fontSize: 12, marginLeft: 10 }}
                    >
                      {" "}
                      {this.state._phoneNum.err}
                    </text>
                  )}
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    id="_email"
                    label="Email"
                    placeholder="Email"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => this.onEmailChange(e)}
                    // value={this.state.email}
                    value={this.state._email.value}
                    error={!this.state._email.isValid}
                    helperText={this.state._email.err}
                    onBlur={e => this.runtimeCheck(e)}
                    variant="outlined"
                    fullWidth
                    // invalid={emailValidate === true ? false : true}
                    onFocus={e => (e.currentTarget.type = "email")}
                    autoComplete={
                      this.state.email === null ? "" : this.state.email
                    }
                    required
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <Autocomplete
                    style={{
                      padding: 6,
                      width: "100%",
                      marginLeft: "10px",
                      marginTop: "15px",
                      borderColor: this.state._address.isValid ? "" : "red"
                    }}
                    id="address"
                    value={this.state.address}
                    onChange={this.onInputChange}
                    type="text"
                    placeholder="Find Your Street address"
                    onPlaceSelected={place => {
                      let stateObj = {};
                      var componentForm = {
                        street_number: "short_name",
                        route: "long_name",
                        locality: "long_name",
                        administrative_area_level_1: "short_name",
                        country: "long_name",
                        postal_code: "short_name"
                      };
                      let address = place.address_components;
                      address !== undefined &&
                        address.forEach(item => {
                          if (componentForm[item.types[0]]) {
                            if (item.types[0] === "locality")
                              stateObj.city = item.long_name;

                            if (item.types[0] === "administrative_area_level_1")
                              stateObj.state = item.long_name;
                            if (item.types[0] === "postal_code")
                              stateObj.zipCode = item.long_name;
                          }
                        });
                      stateObj.address = place.formatted_address;
                      stateObj.lat = place.geometry.location.lat();
                      stateObj.lng = place.geometry.location.lng();
                      this.setState(stateObj);
                      this.setState({
                        _city: {
                          isValid: true,
                          err: ""
                        },
                        _state: {
                          isValid: true,
                          err: ""
                        },
                        _zipCode: {
                          isValid: true,
                          err: ""
                        }
                      });
                    }}
                    types={["address"]}
                    componentRestrictions={{ country: "us" }}
                    fields={[
                      "geometry",
                      "formatted_address",
                      "address_components"
                    ]}
                  />
                  <div
                    style={{
                      fontSize: "x-small",
                      marginLeft: "10px",
                      color: !this.state._address.isValid ? "red" : ""
                    }}
                  >
                    Please use Google auto suggest to exactly show your location
                    on our app maps.
                  </div>
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    id="city"
                    label="City"
                    placeholder="City"
                    className={classes.textField}
                    margin="normal"
                    onChange={this.onInputChange}
                    value={this.state.city}
                    error={!this.state._city.isValid}
                    helperText={this.state._city.err}
                    onBlur={() => {
                      if (
                        this.state.city === null ||
                        this.state.city === undefined ||
                        this.state.city === ""
                      ) {
                        this.setState({
                          _city: {
                            value: this.state.city,
                            isValid: false,
                            err: "Please Specify Your City"
                          }
                        });
                      } else {
                        this.setState({
                          _city: {
                            value: this.state.city,
                            isValid: true,
                            err: ""
                          }
                        });
                      }
                    }}
                    variant="outlined"
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    id="state"
                    label="State"
                    placeholder="state"
                    className={classes.textField}
                    margin="normal"
                    onChange={this.onInputChange}
                    value={this.state.state}
                    error={!this.state._state.isValid}
                    helperText={this.state._state.err}
                    onBlur={() => {
                      if (
                        this.state.state === null ||
                        this.state.state === undefined ||
                        this.state.state === ""
                      ) {
                        this.setState({
                          _state: {
                            value: this.state.state,
                            isValid: false,
                            err: "Please Specify Your State"
                          }
                        });
                      } else {
                        this.setState({
                          _state: {
                            value: this.state.state,
                            isValid: true,
                            err: ""
                          }
                        });
                      }
                    }}
                    variant="outlined"
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    id="zipCode"
                    label="Zip Code"
                    placeholder="Zip Code"
                    className={classes.textField}
                    margin="normal"
                    onChange={this.onInputChange}
                    value={this.state.zipCode}
                    error={!this.state._zipCode.isValid}
                    helperText={this.state._zipCode.err}
                    onBlur={() => {
                      if (
                        this.state.zipCode === null ||
                        this.state.zipCode === undefined ||
                        this.state.zipCode === ""
                      ) {
                        this.setState({
                          _zipCode: {
                            value: this.state.zipCode,
                            isValid: false,
                            err: "Please Specify Your State"
                          }
                        });
                      } else {
                        this.setState({
                          _zipCode: {
                            value: this.state.zipCode,
                            isValid: true,
                            err: ""
                          }
                        });
                      }
                    }}
                    variant="outlined"
                    fullWidth
                    required
                  />
                </Grid>
                {inspectionTypeUI}
                <Grid xs="12" style={{ marginTop: "15px" }}>
                  <div className="custom-control custom-control-alternative custom-checkbox">
                    <input
                      className="custom-control-input"
                      id="cbRegister"
                      type="checkbox"
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="cbRegister"
                    ></label>
                    <span>
                      I agree with the{" "}
                      <a href="#pablo" onClick={e => e.preventDefault()}>
                        Privacy Policy
                      </a>
                    </span>
                    {". "}I also agree that calbit may contact me by email,
                    phone, or SMS (including by automated means) at the email
                    address or number I provide, including for marketing
                    purposes.
                  </div>
                </Grid>{" "}
                <Grid xs="12">
                  <div className="text-center" style={{ marginTop: "15px" }}>
                    <Button
                      className=" btn-lg mt-2"
                      color="primary"
                      type="button"
                      onClick={e => this.handleSubmit(e)}
                      name="submit"
                      tabIndex="-1"
                    >
                      Create account
                    </Button>
                  </div>
                </Grid>
                <Grid item md="12">
                  <div className="row mb-2">
                    {" "}
                    <span className="col-md-4 col-sm-4 col-xs-4"></span>
                    <span className="col-md-2 col-sm-2 col-xs-2"></span>
                    <span className="col-md-4 col-sm-4 col-xs-4">
                      <Button
                        className="bg-transparent text-info"
                        to="/login-page"
                        tag={Link}
                        color=""
                      >
                        {" "}
                        Already have an account?Sign in
                      </Button>
                    </span>
                  </div>
                </Grid>
              </form>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withStyles(styles)(CustomerRegistrationForm);



// WEBPACK FOOTER //
// ./src/pages/CustomerRegistrationPage.js